import { updateProjectAction } from "../../../slice/project-detail";
import { getQuotationList } from "../../../actions/project-management.action";

export const getQuotationListData = async ({ projectId, dispatch }) => {

    const query = `?projectId=${projectId}`;
    let totalRFQSend = 0;
    await dispatch(getQuotationList(query)).then((quotations) => {
        quotations.forEach((quotation) => {
            if (!quotation.draft) {
                totalRFQSend += 1;
            }
        });

        dispatch(updateProjectAction({ totalRFQSend }))
    });
    return totalRFQSend;
}